/**
 * Toggle primary nav: hidden on mobile, visible on ≥lg.
 * Requires:
 *   - <button data-k-menu-btn aria-controls="k-nav" aria-expanded="false">
 *   - <nav id="k-nav" data-k-menu class="hidden lg:block">
 */
(function (Drupal, once) {
  Drupal.behaviors.kMenu = {
    attach(context) {
      // For each nav found once per context
      once("kMenu", "[data-k-menu]", context).forEach((nav) => {
        const root = nav.closest("[data-sticky-header]") || context;
        const btn = root.querySelector("[data-k-menu-btn]");
        if (!btn) return;

        const mq = window.matchMedia("(min-width: 1024px)");

        // ensure we never use the boolean attribute
        const unhide = () => nav.removeAttribute("hidden");

        const sync = () => {
          unhide();
          if (mq.matches) {
            // Desktop: always visible
            nav.classList.remove("hidden");
          } else {
            // Mobile: visible only when expanded
            const expanded = btn.getAttribute("aria-expanded") === "true";
            nav.classList.toggle("hidden", !expanded);
          }
        };

        const toggle = () => {
          const expanded = btn.getAttribute("aria-expanded") === "true";
          btn.setAttribute("aria-expanded", String(!expanded));
          sync();
        };

        btn.addEventListener("click", toggle);
        if (mq.addEventListener) mq.addEventListener("change", sync);
        else mq.addListener(sync); // older Safari

        // Initial state
        sync();
      });
    },
  };
})(Drupal, once);
